import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfirmService } from '../../services/confirm.service';

@Component({
  selector: 'app-confirm-snackbar',
  imports: [TranslatePipe],
  templateUrl: './confirm-snackbar.component.html',
  styleUrl: './confirm-snackbar.component.scss',
})
export class ConfirmSnackbarComponent {
  svc = inject(ConfirmService);

  onConfirm() {
    this.svc.resolve(true);
  }
  onCancel() {
    this.svc.resolve(false);
  }
}
